<template>
    <div class="landing-page auth-layout">
        <div class="landing-page__header-banner">
            <AuthHeader />

            <div class="landing-banner">
                <div class="auth-layout__container">
                    <img
                        src="@/assets/images/landing/banner-cars.png"
                        class="landing-banner__image"
                    />

                    <div class="landing-banner__content">
                        <h2 class="landing-banner__title">Аукционы Hyundai</h2>

                        <div v-if="!isLoggedIn" class="landing-banner__buttons">
                            <UISimpleButton @clicked="goToRegisterPage">
                                Регистрация
                            </UISimpleButton>

                            <UISimpleButton @clicked="goToLoginPage">
                                Войти
                            </UISimpleButton>
                        </div>
                        <div v-else>
                            <UISimpleButton @clicked="goToAuctionsListPage">
                                Перейти к аукционам
                            </UISimpleButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="landing-page__content">
            <div class="process-step-list auth-layout__container">
                <div class="process-step-list__header">
                    <div class="process-step-list__title">
                        Покупайте автомобили Hyundai с пробегом онлайн
                    </div>

                    <div class="process-step-list__subtitle">
                        Просто выбирайте проверенные автомобили от дилеров Hyundai Certified, делайте ставки и побеждайте
                    </div>
                </div>

                <div class="process-step-list__body">
                    <div class="process-step-list__section-title">
                        <span>Как это работает</span>
                        <span class="process-step-list__section-background">Аукционы Hyundai</span>
                    </div>

                    <div class="process-step-list__items">
                        <ProcessStepItem
                            v-for="(step, index) in steps"
                            :key="index"
                            :icon="step.icon"
                            :title="step.title"
                            :description="step.description"
                        />
                    </div>
                </div>
            </div>
        </div>

        <AuthFooter />
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { useRouter } from 'vue-router';
    import { useStorage } from 'vue3-storage';

    import AuthHeader from '@/layouts/AuthLayout/components/AuthHeader.vue';
    import AuthFooter from '@/layouts/AuthLayout/components/AuthFooter.vue';

    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    import ProcessStepItem from '@/views/landing/components/ProcessStepItem/ProcessStepItem.vue';

    const router = useRouter();
    const $storage = useStorage();

    const isLoggedIn = computed(() => {
        return !!$storage.getStorageSync('token');
    });

    const steps = [
        {
            icon: 'step-login.svg',
            title: 'Авторизуйтесь',
            description: 'Чтобы видеть все лоты и участвовать в аукционах',
        },
        {
            icon: 'step-parking.svg',
            title: 'Выберите аукцион',
            description: 'Делайте ставки, следите за ходом торгов и побеждайте',
        },
        {
            icon: 'step-folder.svg',
            title: 'Оформите сделку',
            description: 'Получите документы и ожидайте доставку авто',
        },
    ];

    function goToRegisterPage(): void {
        router.push({ name: 'Register' });
    }

    function goToLoginPage(): void {
        router.push({ name: 'Login' });
    }

    function goToAuctionsListPage(): void {
        router.push({ name: 'AuctionsList' });
    }
</script>

<style scoped lang="scss">
    @use './Landing.scss' as *;
</style>
